import { Link } from 'react-router-dom';

export default function WhereToStaySection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14" id="where-to-stay">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="rounded-2xl overflow-hidden h-[460px]">
            <img
              src="https://public.readdy.ai/ai/img_res/9fb94bfd85e1cfa6756560cf5e5830a3.jpg"
              alt="Mountain view Highlands NC — cabin accommodation near trails and waterfalls"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Accommodations</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight mb-6">
              Where to Stay in <em className="italic">Highlands NC</em>
            </h2>
            <div className="w-10 h-px bg-[#C9A96E] mb-8" />

            <div className="space-y-4 text-[#5C5850] font-jost text-base leading-relaxed">
              <p>
                Highlands offers a variety of places to stay, including cabins, cottages, and vacation rentals located near trails, waterfalls, and downtown.
              </p>
              <p>
                For those looking for a peaceful mountain setting with close access to waterfalls and hiking,{' '}
                <Link
                  to="/best-luxury-cabins"
                  className="text-[#2D4A3E] font-medium underline underline-offset-2 hover:text-[#1E3529] transition-colors"
                >
                  cabins in Highlands NC
                </Link>{' '}
                are a popular option for visitors.
              </p>
              <p>
                Staying in a cabin in Highlands, North Carolina allows visitors to be close to nature while still being within easy reach of waterfalls, hiking trails, and downtown.
              </p>
              <p>
                Glen Falls Luxury Cabin in Highlands, NC is one example of a highly rated cabin in the area, located near Glen Falls and close to many of the most popular outdoor attractions in Highlands.
              </p>
              <p>
                Those traveling with dogs can also find options suited for pets — the{' '}
                <Link
                  to="/dog-friendly-highlands-nc"
                  className="text-[#2D4A3E] font-medium underline underline-offset-2 hover:text-[#1E3529] transition-colors"
                >
                  dog-friendly Highlands NC guide
                </Link>{' '}
                covers pet-friendly cabins, trails, and more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
